import { useState, useEffect } from "react";
import { toast } from "react-toastify";

function PassengerProfileModal({ passenger, onClose, onUpdateDetails }) {
  console.log(passenger, "Passenger data in modal");
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    passengerId: "",
    name: "",
    email: "",
    phone: "",
    gender: "",
    status: "",
  });

  useEffect(() => {
    if (passenger) {
      setFormData({
 
        passengerId: passenger.passengerId || "",
        name: passenger.name || "",
        email: passenger.email || "",
        phone: passenger.phone || "",
        gender: passenger.gender || "",
        status: passenger.status || "",
      });
    }
  }, [passenger]);

  if (!passenger) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSaveDetails = () => {
    setLoading(true);
    const updatedData = {
      ...formData,
      status: formData.status || passenger.status,
    };
    onUpdateDetails(passenger.passengerId, updatedData);
    toast.success("Passenger details updated!");
    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 className="modal-title">Passenger Profile</h2>

        {/* Two-column form */}
        <div className="profile-grid">
          <div className="field">
            <label>Name</label>
            <input name="name" value={formData.name} onChange={handleChange} />
          </div>
          <div className="field">
            <label>Email</label>
            <input
              name="email"
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          <div className="field">
            <label>Phone</label>
            <input
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
          <div className="field">
            <label>Gender</label>
            <input
              name="gender"
              value={formData.gender}
              onChange={handleChange}
            />
          </div>
          <div className="field">
            <label>Status</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="blocked">Blocked</option>
            </select>
          </div>
        </div>

        {/* Action buttons */}
        <div className="modal-actions">
          <button className="btn-outline-green btn-sm" onClick={onClose}>
            Close
          </button>
          <button
            disabled={loading}
            className="btn btn-sm btn-primary"
            onClick={handleSaveDetails}
            style={{ display: "flex", alignItems: "center", gap: 6 }}
          >
            {loading && <span className="spinner" />}
            {loading ? "Saving..." : "Save Details"}
          </button>
          {/* <button
            className="btn btn-sm btn-danger"
            onClick={() => onUpdateStatus(passenger._id, "blocked")}
          >
            Block
          </button>
          <button
            className="btn btn-sm btn-success"
            onClick={() => onUpdateStatus(passenger._id, "active")}
          >
            Activate
          </button> */}
        </div>
      </div>
    </div>
  );
}

export default PassengerProfileModal;
